import { render, staticRenderFns } from "./ValidationWrapper.vue?vue&type=template&id=a1e20120&"
import script from "./ValidationWrapper.vue?vue&type=script&lang=js&"
export * from "./ValidationWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports